module.exports = __webpack_public_path__ + "static/media/exchange.538ce71e.svg";